export const ebookImage =
  'https://cdn.magicpatterns.com/uploads/3HTjMR4H2KEGmf3yJ55PCT/heylloyd-image-1786982137313.png'

export const lifestyleImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/71886571-858a-4ba1-9a51-467cd1a9c411.jpg'

export const foodsImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/8fe4aa70-6e04-45ac-b4f9-97177ae77209.jpg'

export const checkoutUrl =
  'https://jassueboxshop.com/cart/53940591493304:1'

export const price = {
  amount: '$6.390',
  original: '$14.990',
  currency: 'CLP',
  discount: '57%',
  label: 'Precio especial de lanzamiento',
}

export const failedAttempts = [
  {
    title: 'Las dietas restrictivas',
    text: 'Elevan el estrés y hacen que tu cuerpo retenga más líquido en lugar de soltarlo.',
  },
  {
    title: 'El ejercicio intenso sin descanso',
    text: 'Dispara el cortisol, la hormona que le ordena a tu cuerpo acumular grasa justo en el vientre.',
  },
  {
    title: 'Los alimentos "saludables"',
    text: 'Legumbres y fibras crudas fermentan en tu intestino porque tus enzimas no están preparadas.',
  },
  {
    title: 'Separar el estrés de la digestión',
    text: 'Ignorar esa conexión bloquea cualquier pérdida de peso real, por mucho que te esfuerces.',
  },
]

export const bundle = [
  {
    name: 'La Guía Maestra: Método Vientre Plano 21D',
    text: 'El documento completo en PDF con el protocolo, la ciencia detrás del reseteo y tu plan de alimentación.',
    featured: true,
  },
  {
    name: 'El Calendario de Ruta',
    text: 'Qué hacer día por día durante los 21 días para no fallar ni improvisar.',
  },
  {
    name: 'Lista de Compras Anti-Inflamatoria',
    text: 'Los aliados que debes tener en tu cocina, todos disponibles en el supermercado.',
  },
  {
    name: 'Protocolo SOS',
    text: 'Cómo desinflamarte en 60 minutos cuando tienes una ocasión especial.',
  },
  {
    name: 'Guía de Suplementación Estratégica',
    text: 'Magnesio, enzimas y probióticos explicados sin promesas falsas.',
  },
]

export const forYou = [
  'Mujeres que sufren de colon irritable o hinchazón frecuente.',
  'Profesionales con alto nivel de estrés que sienten pesadez abdominal.',
  'Madres que quieren recuperar su figura post-parto sanando desde adentro.',
  'Cualquier mujer que quiera dejar de esconderse detrás de ropa ancha.',
]

export const notForYou = [
  'Personas que buscan una "pastilla milagrosa" sin cambiar hábitos básicos.',
  'Quienes no estén dispuestos a dejar los ultraprocesados por 21 días.',
  'Personas que prefieren seguir contando calorías en lugar de sanar su metabolismo.',
]

export const steps = [
  {
    title: 'Descarga inmediata',
    text: 'Recibes todo el material al instante después de tu compra, sin esperas ni envíos.',
  },
  {
    title: 'Protocolo de Reseteo',
    text: 'Sigues los primeros 7 días diseñados para limpiar toxinas y bajar la inflamación intestinal.',
  },
  {
    title: 'Rituales de cortisol',
    text: 'Aplicas los rituales de control de cortisol para mantener tu vientre plano todo el día.',
  },
]

export const faqs = [
  {
    q: '¿Necesito comprar ingredientes caros?',
    a: 'No. Todos los alimentos del método se encuentran en cualquier supermercado local de Chile, y la Lista de Compras está pensada para cuidar tu presupuesto.',
  },
  {
    q: '¿Es una dieta keto?',
    a: 'No. Es un protocolo anti-inflamatorio equilibrado: no elimina grupos completos de alimentos ni te obliga a vivir en cetosis.',
  },
  {
    q: '¿Cuánto tiempo me tomará ver resultados?',
    a: 'Verás cambios en tu inflamación desde la primera semana, y el efecto se consolida al completar los 21 días.',
  },
  {
    q: '¿El pago es seguro?',
    a: 'Sí. Utilizamos plataformas de pago encriptadas con seguridad de nivel bancario.',
  },
]
